import React from "react";

const UserRatingStar = ({ className }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M8 8.50049L0.0341797 6.07471C0.12791 5.73773 0.410809 5.4585 0.816406 5.4585H5.11914C5.47225 5.45848 5.78529 5.22081 5.89453 4.86963L7.22461 0.588379C7.34679 0.195738 7.67334 -0.000586242 8 -0.000488245V8.50049Z"
        fill="#FFC531"
      />
      <path
        d="M8.00049 8.50049L15.9653 6.07568C15.8718 5.73836 15.59 5.45851 15.1841 5.4585H10.8813C10.5282 5.4585 10.2142 5.22091 10.105 4.86963L8.77588 0.588379C8.65379 0.195841 8.32703 -0.000390596 8.00049 -0.000488281V8.50049Z"
        fill="#FFB324"
      />
      <path
        d="M12.8979 15.8472C12.635 16.0352 12.272 16.0712 11.9604 15.8345L8.47998 13.189C8.1942 12.9718 7.80677 12.9718 7.521 13.189L4.03955 15.8345C3.72796 16.0711 3.36501 16.0353 3.10205 15.8472L8.00049 8.50049L12.8979 15.8472Z"
        fill="#F89F1A"
      />
      <path
        d="M7.99953 8.49463L3.10012 15.8413C2.82449 15.6434 2.65981 15.2775 2.78469 14.8755L4.11379 10.5952C4.22295 10.2438 4.10367 9.85828 3.81789 9.64111L0.336446 6.99561C0.0259465 6.75949 -0.0548212 6.38888 0.0337115 6.06982L7.99953 8.49463Z"
        fill="#FEB122"
      />
      <path
        d="M7.99916 8.49463L12.8986 15.8413C13.1743 15.6435 13.3398 15.2775 13.215 14.8755L11.8849 10.5952C11.7758 10.2439 11.8951 9.85829 12.1808 9.64111L15.6622 6.99561C15.9729 6.75954 16.0544 6.38892 15.966 6.06982L7.99916 8.49463Z"
        fill="#F39415"
      />
    </svg>
  );
};

export default UserRatingStar;
